"use client"

import { EstimateWithLabel } from "@/components/Complex/EstimateWithLabel"
import { useConfig } from "@/hooks/useConfig"
import { cn } from "@/lib/utils/utils"

interface EstimateProps {
  prep_time: string | null
  action_time: string | null
  className?: string
}

export function Estimate({ prep_time, action_time, className }: EstimateProps) {
  const { t } = useConfig()

  if (!prep_time && !action_time) {
    return null
  }

  return (
    <div className={cn("flex gap-6", className)}>
      <EstimateWithLabel
        time={prep_time}
        label={t("config_mission_estimate_label_prep_time")}
        badgeTextColor="text-fuchsia-500"
        badgeBackgroundColor="bg-pink-50"
      />
      <EstimateWithLabel
        time={action_time}
        label={t("config_mission_estimate_label_action_time")}
        badgeTextColor="text-violet-600"
        badgeBackgroundColor="bg-purple-50"
      />
    </div>
  )
}
